import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HeroUIProvider } from '@heroui/react';

// PWA Update Handler
const handlePWAUpdates = () => {
  if ('serviceWorker' in navigator) {
    // Force unregister any existing service workers first
    navigator.serviceWorker.getRegistrations().then(registrations => {
      return Promise.all(registrations.map(registration => registration.unregister()));
    }).then(() => {
      console.log('🔄 PWA: Cleared existing service workers');
      
      // Register the service worker with cache busting
      return navigator.serviceWorker.register('/sw.js?v=' + Date.now());
    }).then((registration) => {
      console.log('🔄 PWA: Service Worker registered successfully:', registration);
      
      // Force update check
      registration.update();
      
      // Force skip waiting
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    }).catch((error) => {
      console.error('❌ PWA: Service Worker registration failed:', error);
    });

    // Listen for service worker updates
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'FORCE_REFRESH') {
        console.log('🔄 PWA: Force refresh requested');
        // Only refresh if explicitly requested and not in a loop
        const lastRefresh = sessionStorage.getItem('last-refresh');
        const now = Date.now();
        if (!lastRefresh || (now - parseInt(lastRefresh)) > 5000) {
          sessionStorage.setItem('last-refresh', now.toString());
          window.location.reload();
        }
      }
      
      if (event.data && event.data.type === 'SW_UPDATED') {
        console.log('🔄 PWA: Service Worker updated to version', event.data.version);
        // Show a subtle notification to the user
        if ('Notification' in window && Notification.permission === 'granted') {
          new Notification('Ascend Community Updated', {
            body: `Updated to version ${event.data.version}. The app is now running the latest version.`,
            icon: '/ascend-logo.png',
            tag: 'pwa-update',
            requireInteraction: false
          });
        }
      }

      // New: bubble update-available to the app even if SW posted before App mounted
      if (event.data && event.data.type === 'UPDATE_AVAILABLE') {
        console.log('🔄 PWA: UPDATE_AVAILABLE received in index.tsx');
        window.dispatchEvent(new Event('APP_UPDATE_AVAILABLE'));
      }
    });

    // Check for updates on app load
    navigator.serviceWorker.ready.then((registration) => {
      // Only check for updates, don't force them
      registration.update();
    });

    // Listen for new service worker installations
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.log('🔄 PWA: New service worker activated');
      // Don't automatically refresh - let user control this
    });
  }
};

// Initialize PWA update handling
handlePWAUpdates();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <HeroUIProvider>
    <App />
  </HeroUIProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
